import { baseApi, TAG } from '../../app/api/baseApi'
const CONNECTION_LIST = { type: TAG.CONNECTION, id: 'LIST' }
export const connectionsApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getConnections: builder.query({
            query: () => '/Client/connections',
            transformResponse: (data) => (Array.isArray(data) ? data : []),
            providesTags: (connections = []) => [
                CONNECTION_LIST,
                ...connections.map((connection) => ({ type: TAG.CONNECTION, id: connection.id }))
            ]
        }),
        getConnectionInstance: builder.query({
            query: ({ connectorId, instanceId }) => `/Client/connections/${connectorId}/instances/${instanceId}`,
            providesTags: (result, error, { connectorId }) => [{ type: TAG.CONNECTION, id: connectorId }]
        }),

        getDashboard: builder.query({
            query: () => '/Dashboard',
            providesTags: [TAG.DASHBOARD]
        }),
        getSixMonthSummary: builder.query({
            query: () => '/v2/subscription/reports/all/summary/6months',
            transformResponse: (data) => (Array.isArray(data) ? data : []),
            providesTags: [TAG.DASHBOARD]
        })
    })
})
export const {
    useGetConnectionsQuery,
    useGetConnectionInstanceQuery,
    useLazyGetConnectionInstanceQuery,
    useGetDashboardQuery,
    useGetSixMonthSummaryQuery
} = connectionsApi
export const CONNECTION_LIST_TAG = CONNECTION_LIST
export const useConnection = (connectorId) => useGetConnectionsQuery(undefined, {
    selectFromResult: ({ data, isLoading, isFetching, isError, error }) => ({
        connection: data ? data.find((item) => String(item.id) === String(connectorId)) || null : null,
        connectionCount: data ? data.length : 0,
        isLoading,
        isFetching,
        isError,
        error
    })
})
export const describeConnection = (connection) => {
    if (!connection) {
        return null
    }
    const instance = (connection.instances && connection.instances[0]) || {}
    return {
        connectorId: connection.id,
        instanceId: instance.id,
        instance,
        subscriptionId: connection.subscriptionId,
        clientId: connection.clientId,
        name: connection.name || '',
        displayName: (connection.name || '').replace(/^i95Dev\s*/, ''),
        featureName: connection.featureName,
        expiryDate: connection.expiryDate,
        isSetupCompleted: Boolean(instance.isSetupCompleted),
        source: connection.source || {},
        target: connection.target || {}
    }
}
